/* eslint-disable max-nested-callbacks */
// 组空间
import React, { useContext, useState, useEffect, useMemo, useCallback, useRef } from "react";
import api from "../../api";
import contextMenus from "../../contextMenus";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { ColumnsItem, JustifyContent } from "../../components/TableList/BaseComponents/Header";
import { getIconUrl, openLink, partialRefresh, removeDuplicate, time } from "../../util";
import { changeEgovUrl } from "@/utils/tools";
import ContextMenu from "../../components/List/ContextMenu";
import { message } from "antd";
import Tags, { TagType } from "../../components/Tags";
import Filters from "../../components/List/Filters";
import { Order, Sort, timeFilter, titleFilter } from "../../components/List/Filters/config";
import BatchControl from "../../components/List/BatchControlNew";
import batchOperate, { PageRouteName } from "../../batchOperate";
import { connect } from "dvajs";
import { JoyspaceState } from "@/models/joyspace";
import ShareIcon from "../../components/List/ShareIcon";
import { ActionFnEnum, ContextMenuMode, FileType, MenusType, OpenFolderStatus } from "../../types";
import { pageSize } from "../../config/basics.config";
import SyncStatusTag from "../../components/SyncStatusTag";
import { SyncStatusEunm } from "@/components/Joyspace/controllers/JoyspaceController";
import openDeleteModal from "../../contextModal/DeleteModal";
import openErrorDeleteModal from "../../contextModal/ErrorDeleteModal";
import { folderType } from "../../config/permissions.config";
import UpdataService from "../../reloadUtils";
import { useNavigator } from "@/utils/NetworkCheck";
import { useListData } from "../../components/TableList/Use/useListData";

// let params = {
//     srot: Sort.UpDateTime,
//     order: Order.DESC,
// };

interface IProps {
  isReload?: boolean; // 新建文件/文件夹后，用于刷新列表
  folderId: string;
  setFolder: Function;
  gname: string;
  gid: string;
  getFolderInfoById: Function;
  filterInfo: any;
  folderName: string;
  folderMap: any;
}
const PartialUpdata = Object.create(UpdataService);
const key = MenusType.GROUPSPACE;
function PageList(props: IProps) {
  const {
    isReload,
    getFolderInfoById,
    folderId,
    setFolder,
    gname,
    gid,
    folderName,
    folderMap,
    filterInfo
  } = props;

  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const { onLine } = globalContext;
  const [defaultCheckedList, setDefaultCheckedList] = useState<string[]>([]);
  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    pageIndex,
    setPageIndex,
    selecteds,
    select,
    onButtom,
    setCategoryId,
    reload,
    setFilterInfo
  } = useListData({
    key,
    defaultCategoryId: folderId,
    requestPagesFunc: api.pages.getGroupSpacePageList,
    requestCategoriesuFunc: api.pages.getGroupSpaceFolderList,
    defaultFilterInfo: filterInfo,
    isGroup: true
  });
  useEffect(() => {
    setCategoryId(folderId);
  }, [folderId, setCategoryId]);
  useEffect(() => {
    setFilterInfo(filterInfo);
  }, [filterInfo, setFilterInfo]);
  const [columns, setColumns] = useState<ColumnsItem[]>([
    // 排列方式
    {
      title: "",
      key: "title",
      dataIndex: "title",
      ellipsis: true,
      filters: true,
      render: () => (
        <Filters isArrowDownIcon={true} from={PageRouteName.GROUP} menu={titleFilter()} />
      )
    },
    {
      title: "",
      key: "time",
      dataIndex: "time",
      width: "20%",
      style: {
        minWidth: "142px"
      },
      justifyContent: JustifyContent.Left,
      filters: true,
      render: () => <Filters from={PageRouteName.GROUP} menu={timeFilter()} />
    },
    {
      title: "",
      key: "actions",
      dataIndex: "actions",
      actions: true,
      width: "10%",
      style: {
        minWidth: "30px"
      },
      justifyContent: JustifyContent.Center
    }
  ]);
  useEffect(() => {
    list.forEach((item) => {
      if (typeof item.page_type === "undefined") {
        folderMap[item.id] = item;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);
  // 列表显示多选框
  useMemo(() => {
    let _columns = [...columns];
    const index = _columns.findIndex((item) => item.key === "checkbox");
    const item = _columns.filter((item) => item.filters);
    if (onLine && index === -1) {
      _columns.unshift({
        title: "",
        key: "checkbox",
        checkbox: true,
        dataIndex: "id",
        width: 30
      });
    } else if (!onLine && index !== -1) {
      _columns.splice(0, 1);
    }
    setColumns(_columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  const openPage = (columnsItem: ColumnsItem, item: any) => {
    // eslint-disable-next-line no-debugger
    if (!item.page_id) {
      //   console.log(item, "itemitemitemitemitemitem");
      events.emit("groupspace.setSearchFolderId", item.id);
      setFolder(item);
      return;
    }
    if (!item.status) {
      openDeleteModal(FileType.Page, item.id);
      return;
    }
    if (item.syncStatus === SyncStatusEunm.PROCESS) {
      message.error("文档同步中，请同步完成后查看");
      return;
    }
    if (item.syncStatus === SyncStatusEunm.DATAERROR) {
      openErrorDeleteModal(item);
      return;
    }
    openLink(item, globalContext.appRuntimeEnv.joyspaceHost);
  };
  const getCheckedIds = (ids: string[] = []) => {
    const reslut = columns.find((item: ColumnsItem) => item.checkbox);
    if (!reslut) {
      return;
    }
    const _set = new Set();
    for (let id of ids) {
      for (let item of list) {
        if (item[reslut.dataIndex] === id) {
          _set.add(item);
        }
      }
    }
    select(_set);
  };
  const setData = useCallback((data: any) => {
    events.emit("list.partial.refresh", {
      changeData: data,
      key
    });
  }, []);
  useEffect(() => {
    events.on("table-setData", setData);
    return () => {
      events.off("table-setData", setData);
    };
  }, [setData]);
  return (
    <div className="joyspace-list-table joyspace-child-list">
      <TableList
        key={key}
        // disabledHeader={!onLine }
        from={PageRouteName.GROUP}
        isLoadMore={isLoadMore}
        columns={columns}
        list={list}
        loading={loading}
        pagination={true}
        defaultCheckedList={defaultCheckedList}
        isGroupSpace={true}
        isRoot={false}
        diffHeight={15}
        folderFrom={{
          folderId,
          fromName: folderName,
          spaceId: gid,
          draggerUploadShow: true
        }}
        classNames="group-context-menus"
        renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
          //   PartialUpdata.setList(list);
          return item.type === 3 ? (
            <ContextMenu
              render={contextMenus.category("GROUP")} // 文件夹更多操作
              callbackProps={{
                contextMenuMode,
                data: item,
                gid,
                originId: folderId || gid,
                setData,
                remove: () => {
                  console.log("remove");
                },
                reload: () => {
                  reload();
                }
              }}
            />
          ) : (
            <ContextMenu
              render={contextMenus.page("GROUP", globalContext, undefined, gname)} // 文档更多操作
              callbackProps={{
                contextMenuMode,
                data: item,
                originId: folderId,
                setData,
                remove: () => {
                  console.log("remove");
                },
                reload: () => {
                  console.log("reload");
                  reload();
                }
              }}
            />
          );
        }}
        preOptions={(item, data, isExist) => {
          return (
            item.dataIndex === "title" &&
            (data.icon_url ? (
              <img
                src={
                  !isExist ? changeEgovUrl(data.icon_url) : getIconUrl(data.type || data.page_type)
                }
                data-icon
              />
            ) : (
              <ShareIcon isShared={data.page_type ? data.isShared : true} />
            ))
          );
        }}
        afterOptions={(item, data) => {
          return (
            item.dataIndex === "title" && (
              <>
                {/* 是否显示收藏的星星 */}
                {/* {data.isCollected && <Tags left={5} TagType={TagType.Follow} />} */}
                {data.open === OpenFolderStatus.OPEN && <Tags left={5} TagType={TagType.Open} />}
              </>
            )
          );
        }}
        contentRender={(columnsItem: ColumnsItem, item: any) => {
          return (
            columnsItem.dataIndex === "time" &&
            item.isNew && <SyncStatusTag status={item.syncStatus} />
          );
        }}
        onButtom={onButtom}
        handleItem={openPage}
        getCheckedIds={getCheckedIds}
        footerHeight={50}
        allowDraggble={true}
        footerRender={() => {
          PartialUpdata.setList(list);
          return (
            <BatchControl
              key={key}
              selecteds={selecteds as any}
              select={select}
              render={contextMenus.page("GROUP", globalContext, undefined, gname)}
              categoryRender={contextMenus.category("GROUP")}
              batchRender={batchOperate.batch("GROUP", undefined, {
                gname,
                gid
              })}
              callbackProps={{
                originId: folderId,
                setData,
                reload: () => {
                  console.log("reload");
                  reload();
                }
              }}
            />
          );
        }}
      />
    </div>
  );
}

function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return {
    filterInfo: joyspace.filterInfo
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getFolderInfoById(id: any, params: any) {
      return dispatch({
        type: "joyspace/freshFolderTreeById",
        payload: {
          id,
          params
        }
      });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PageList);
